/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Tool_Grants_Revoke_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not take the tool away." |
*
* @param {Spaces_Tool_Grants_Revoke_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_tool_grants_revoke_error = /** @type {((inputs?: Spaces_Tool_Grants_Revoke_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Tool_Grants_Revoke_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Freigabe konnte nicht entzogen werden.")
	return /** @type {LocalizedString} */ ("Could not take the tool away.")
});